
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/widget/product",
      function () {
        return require("private-next-pages/blog/widget/product.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/widget/product"])
      });
    }
  